import dig from '@/Dig'

const DEFAULT_WEEKS_SHOWN = 2
const MOBILE_WEEKS_SHOWN = 1

// Below this width the Online Scheduler clamps to a single week.
// Mirrors `$mobile-breakpoint` in `app/assets/stylesheets/variables.scss`, which is
// what the scheduler's collapsed company header keys on — so the Online Scheduler has
// one definition of "mobile" rather than two. Change the two together.
export const MOBILE_MAX_WIDTH = 600

// `matchMedia` rather than `window.innerWidth`: it evaluates the identical
// comparison to the header's CSS media query, so the two features cannot disagree
// at the boundary — `innerWidth` counts the scrollbar and can differ by ~15px.
// The `innerWidth` branch is a fallback for environments without `matchMedia`
// (jsdom under Jest, very old browsers), not the preferred path.
const isMobileViewport = () => {
  if (typeof window === 'undefined') return false

  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
  }

  return window.innerWidth <= MOBILE_MAX_WIDTH
}

// Number of weeks of availability the Online Scheduler shows at once.
// Backend-driven via the company's scheduler_weeks_shown setting; falls back
// to the default when the stored value is missing or not a positive number.
//
// On a mobile-width viewport the result is clamped to one week regardless of the
// company's setting: at 2 or 4 weeks the 7-column grid is a long scroll on a phone,
// making a mis-tap on the wrong day likely. The clamp is a FLOOR, never
// a lift — a company already set to 1 week is unaffected — and it is resolved once,
// at call time; nothing re-evaluates it on resize or rotation.
//
// Both consumers read through here — Schedule.vue's openings prefetch fan-out, and
// SelectDate.vue's calendar duration, range button text and "next" fetch range — so
// the clamp reaches all of them without either component knowing about viewports.
export default (company) => {
  const weeks = parseInt(
    dig(company, 'attributes.settings.scheduler_weeks_shown', DEFAULT_WEEKS_SHOWN)
  )
  const configured = weeks > 0 ? weeks : DEFAULT_WEEKS_SHOWN

  return isMobileViewport() ? MOBILE_WEEKS_SHOWN : configured
}
